import styled from "styled-components";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto 60px;
  margin-top: 40px;
  box-sizing: border-box;

  ${media.downTablet`
    margin-bottom: 40px;
    margin-top: 24px;
  `}
`;

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const WelcomeLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const WelcomeAvatar = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e8521a, #ff8c5a);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
`;

export const WelcomeText = styled.div``;

export const WelcomeGreeting = styled.p`
  margin: 0;
  color: #9ca3af;
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const WelcomeName = styled.h3`
  margin: 0;
  color: #111;
  font-family: Poppins;
  font-size: 32px;
  font-weight: 700;
  span {
    color: #e8521a;
  }

  ${media.downMobile`
    font-size: 24px;
  `}
`;

export const WelcomeRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const HeaderStat = styled.div`
  padding: 6px 10px;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  background: #fff;
  text-align: center;
`;

export const HeaderStatValue = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  &.orange {
    color: #e8521a;
  }
  &.green {
    color: #16a34a;
  }
`;

export const HeaderStatLabel = styled.p`
  margin: 2px 0 0;
  color: #9ca3af;
  font-size: 10px;
`;

export const HeaderDivider = styled.span`
  width: 1px;
  height: 28px;
  background: #ededed;
`;

export const IndicatorLabel = styled.p`
  margin: 0;
  color: #9ca3af;
  font-size: 11px;
`;

export const SliderWrap = styled.div`
  margin-top: 12px;
  width: 100%;
  height: 414px;
  overflow: hidden;
  position: relative;
  border-radius: 10px;

  ${media.downTablet`
    height: auto;
    min-height: 360px;
  `}

  ${media.downMobile`
    min-height: 320px;
  `}
`;

export const SlidesTrack = styled.div`
  display: flex;
  height: 100%;
  width: 400%;
  transition: transform 0.55s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Slide = styled.div`
  width: 25%;
  min-width: 25%;
  flex: 0 0 25%;
  height: 100%;
  padding: 0 72px;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  ${media.downTablet`
    padding: 20px 18px 36px;
    align-items: flex-start;
  `}

  ${media.downMobile`
    padding: 16px 12px 32px;
  `}
  ${({ variant }) => {
    if (variant === "dark") return "background:#0a0a0a;";
    if (variant === "darkBlue") return "background:linear-gradient(135deg,#0a0f1e 0%,#0a0a0a 100%);";
    if (variant === "lightGreen") return "background:linear-gradient(135deg,#f0fdf4 0%,#fff 60%);";
    return "background:linear-gradient(135deg,#fff5f2 0%,#fff 60%);";
  }}
`;

export const SlideContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  min-width: 0;
  ${media.downTablet`
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  `}
`;

export const SlideLeft = styled.div`
  flex: 1;
  max-width: 560px;
  min-width: 0;

  ${media.downTablet`
    max-width: 100%;
  `}
`;

export const SlideRight = styled.div`
  width: min(470px, 40%);
  min-width: 320px;
  flex-shrink: 1;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;

  ${media.downTablet`
    width: 100%;
    min-width: 0;
    justify-content: flex-start;
  `}
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
  margin-bottom: 14px;
  text-transform: uppercase;
  ${({ variant }) => {
    if (variant === "blue") return "color:#60a5fa;border:1px solid rgba(59,130,246,.25);background:rgba(59,130,246,.12);";
    if (variant === "green") return "color:#16a34a;border:1px solid rgba(22,163,74,.2);background:rgba(22,163,74,.08);";
    return "color:#e8521a;border:1px solid rgba(232,82,26,.25);background:rgba(232,82,26,.12);";
  }}
`;

export const BadgeDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e8521a;
  &.blue {
    background: #60a5fa;
  }
`;

export const SlideTitle = styled.h2`
  margin: 0 0 12px;
  font-family: Poppins;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.05;
  color: ${({ variant }) => (variant === "dark" ? "#fff" : "#111")};
  .orange {
    color: #e8521a;
  }
  .green {
    color: #16a34a;
  }
  .blue {
    color: #60a5fa;
  }
  ${media.downTablet`
    font-size: 30px;
  `}

  ${media.downMobile`
    font-size: 26px;
  `}
`;

export const SlideDescription = styled.p`
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
`;

export const PrimaryBtn = styled.button`
  background: #e8521a;
  color: #fff;
  border: 0;
  border-radius: 9px;
  padding: 12px 22px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &.green {
    background: #16a34a;
  }
  &.blue {
    background: #1d4ed8;
  }
`;

export const SecondaryBtn = styled.button`
  margin-left: 8px;
  border-radius: 9px;
  padding: 12px 22px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${({ variant }) => (variant === "dark" ? "rgba(255,255,255,.12)" : "#e0e0e0")};
  color: ${({ variant }) => (variant === "dark" ? "#c8ced8" : "#6b7280")};
  background: transparent;
`;

export const ProductCards = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
  align-items: flex-end;
  overflow: hidden;
  ${media.downTablet`
    justify-content: flex-start;
    gap: 8px;
    flex-wrap: wrap;
  `}
`;

export const ProductCard = styled.div`
  width: ${({ featured }) => (featured ? "146px" : "132px")};
  background: ${({ featured }) => (featured ? "rgba(232,82,26,.1)" : "rgba(255,255,255,.05)")};
  border: 1px solid ${({ featured }) => (featured ? "rgba(232,82,26,.25)" : "rgba(255,255,255,.09)")};
  border-radius: 14px;
  padding: 12px;
  text-align: center;

  ${media.downMobile`
    width: 110px;
    padding: 10px;
  `}
`;

export const ProductCardEmoji = styled.span`
  font-size: 30px;
`;

export const ProductCardName = styled.p`
  margin: 8px 0 6px;
  color: #d1d5db;
  font-size: 11px;
`;

export const ProductCardBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 9px;
  color: #ff8c5a;
  background: rgba(232, 82, 26, 0.2);
`;

export const ScoreCard = styled.div`
  width: 100%;
  max-width: 340px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  padding: 18px;
  box-sizing: border-box;
`;

export const ScoreRow = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #6b7280;
  font-size: 12px;
`;

export const ScoreBar = styled.div`
  margin-top: 6px;
  height: 4px;
  background: #f0f0f0;
  border-radius: 999px;
  overflow: hidden;
`;

export const ScoreBarFill = styled.div`
  height: 100%;
  width: ${({ width }) => width || "0%"};
  &.green {
    background: #16a34a;
  }
  &.orange {
    background: #f59e0b;
  }
`;

export const ScoreValue = styled.span`
  font-weight: 700;
  &.green {
    color: #16a34a;
  }
  &.orange {
    color: #f59e0b;
  }
`;

export const MarketplaceGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 100%;
  max-width: 340px;
`;

export const MarketplaceCard = styled.div`
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid rgba(255, 255, 255, 0.15);
  &.shopify {
    background: rgba(150, 191, 72, 0.1);
    color: #96bf48;
  }
  &.ebay {
    background: rgba(229, 50, 56, 0.1);
    color: #e53238;
  }
  &.amazon {
    background: rgba(255, 153, 0, 0.1);
    color: #ff9900;
  }
  &.tiktok {
    background: rgba(255, 0, 80, 0.1);
    color: #ff0050;
  }
`;

export const PlanCard = styled.div`
  width: 100%;
  max-width: 300px;
  background: #fff;
  border: 2px solid #bbf7d0;
  border-radius: 16px;
  padding: 22px;
  box-sizing: border-box;
`;

export const PlanName = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
`;

export const PlanTag = styled.span`
  margin-left: 8px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #dcfce7;
  color: #16a34a;
  font-size: 9px;
  text-transform: uppercase;
`;

export const PlanPrice = styled.p`
  margin: 12px 0;
  color: #16a34a;
  font-size: 36px;
  font-weight: 800;
`;

export const PlanPriceUnit = styled.span`
  color: #9ca3af;
  font-size: 14px;
  font-weight: 400;
`;

export const PlanFeature = styled.p`
  margin: 0 0 6px;
  color: #166534;
  font-size: 12px;
`;

export const DotsWrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  display: flex;
  gap: 7px;
  ${media.downMobile`
    bottom: 10px;
  `}
`;

export const Dot = styled.button`
  border: 0;
  border-radius: 999px;
  height: 6px;
  width: ${({ $active }) => ($active ? "22px" : "6px")};
  background: ${({ $active, $dark }) =>
    $active ? "#e8521a" : $dark ? "rgba(255,255,255,.25)" : "rgba(0,0,0,.18)"};
  cursor: pointer;
`;

export const NavButtons = styled.div``;

export const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  font-size: 16px;
  color: ${({ $dark }) => ($dark ? "#fff" : "#111")};
  background: ${({ $dark }) => ($dark ? "rgba(255,255,255,.1)" : "rgba(0,0,0,.08)")};
  &:first-child {
    left: 16px;
  }
  &:last-child {
    right: 16px;
  }
  ${media.downTablet`
    top: auto;
    bottom: 10px;
    transform: none;
  `}
`;
